import React, { useEffect, useState } from "react";
import { Button, FormControlLabel, MenuItem, Select, Switch, TextField } from "@mui/material";

export default function StaffVouchersShowFilters({
  filter,
  setFilter,
  hideActioned,
  setHideActioned,
  campaigns,
  searchCampaign,
  setSearchCampaign,
  fromParent,
  toParent,
  sortVal,
  setSortVal,
  showRedeemed,
  setShowRedeemed,
  showUnredeemed,
  setShowUnredeemed,
  setFrom,
  setTo,
  setPage,
  version,
}) {
  const [filterLocal, setFilterLocal] = useState(filter);

  useEffect(() => {
    setFilterLocal(filter);
  }, [filter]);

  // Function to determine the label for the date fields
  const getDateLabel = () => {
    if (showRedeemed && !showUnredeemed) return "actioned";
    if (!showRedeemed && showUnredeemed) return "created";
    return "created/actioned";
  };

  const sortArray = [
    { id: "created_at", label: "Issued date" },
    { id: "transaction_date", label: "Redeemed date" },
    { id: "a_date_surgery", label: "Procedure date" },
    { id: "a_microchip_number", label: "Microchip number" },
    { id: "supplier_business_name", label: "Vet" },
    { id: "owner_name", label: "Owner" },
    { id: "voucher_nr", label: "Voucher number" },
  ];

  return (
    <>
      <div
        style={{
          flex: "1 0 0%",
          display: "flex",
          margin: "10px 0",
          padding: 5,
          background: "#e9f5ff",
          flexWrap: "wrap",
        }}
      >
        {/* Redeemed Switch: unchecked and disabled if version is "unused" */}
        <FormControlLabel
          control={
            <Switch
              checked={version === "unused" ? false : showRedeemed}
              onChange={
                version === "unused"
                  ? undefined
                  : (e) => {
                      setShowRedeemed(e.target.checked);
                      setPage(1); // Reset page to 1
                    }
              }
              disabled={version === "unused"}
            />
          }
          size="small"
          sx={{ m: 1 }}
          label="Redeemed"
        />
        <FormControlLabel
          control={
            <Switch
              checked={showUnredeemed}
              onChange={(e) => {
                setShowUnredeemed(e.target.checked);
                setPage(1);
              }}
            />
          }
          size="small"
          sx={{ m: 1 }}
          label="Issued"
        />
        <FormControlLabel
          control={
            <Switch
              checked={hideActioned === true}
              onChange={(e) => {
                setHideActioned(e.target.checked);
                setPage(1);
              }}
            />
          }
          size="small"
          sx={{ m: 1 }}
          label="Hide actioned"
        />
        <div>
          <Select
            sx={{ margin: 1 }}
            labelId="select-campaigns-label"
            id="select-campaigns"
            value={searchCampaign}
            label="Campaign"
            onChange={(e) => {
              setSearchCampaign(e.target.value);
              setPage(1);
            }}
          >
            <MenuItem value="all">All campaigns</MenuItem>
            {campaigns.map((c) => (
              <MenuItem key={c.id} value={c.id}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </div>
        <TextField
          sx={{ margin: 1 }}
          type="date"
          label={`From (${getDateLabel()})`}
          focused
          value={fromParent}
          onChange={(e) => {
            setFrom(e.target.value);
            setPage(1);
          }}
          onBlur={(e) => {
            setFrom(e.target.value);
            setPage(1);
          }}
        />
        <TextField
          sx={{ margin: 1 }}
          type="date"
          label={`To (${getDateLabel()})`}
          focused
          value={toParent}
          onChange={(e) => {
            setTo(e.target.value);
            setPage(1);
          }}
          onBlur={(e) => {
            setTo(e.target.value);
            setPage(1);
          }}
        />
        <Button variant="">Update</Button>
        <Button
          disabled={campaigns.length === 0}
          onClick={() => {
            setFrom(false);
            setTo(false);
            setFilter("");
            setShowRedeemed(true);
            setShowUnredeemed(true);
            setHideActioned(true);
            setPage(1);
          }}
        >
          Reset
        </Button>
      </div>
      <div
        style={{
          flex: "1 0 0%",
          display: "flex",
          margin: "10px 0",
          padding: 5,
          background: "#e9f5ff",
          flexWrap: "wrap",
        }}
      >
        <div style={{ flexGrow: 1, paddingRight: 20 }}>
          <TextField
            sx={{ margin: 1 }}
            type="text"
            fullWidth
            label="Search for Voucher"
            focused
            value={filterLocal}
            onChange={(e) => setFilterLocal(e.target.value)}
          />
        </div>
        <div style={{ flexGrow: 0 }}>
          <Button
            sx={{ margin: 2 }}
            variant="contained"
            onClick={() => {
              setFilter(filterLocal);
              setPage(1);
            }}
          >
            Search
          </Button>
        </div>
      </div>
    </>
  );
}
